import { render } from "./customButton.vue?vue&type=template&id=4945076a"
import script from "./customButton.vue?vue&type=script&lang=js"
export * from "./customButton.vue?vue&type=script&lang=js"

import "./customButton.vue?vue&type=style&index=0&id=4945076a&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__